import React from 'react';
import PropTypes from 'prop-types';

import { ProductCard } from '../../../common/product-card';
import { SECTION_TYPES } from '../../../models/Home';
import { Alert } from '../alert';
// import { MainBanner } from '../main-banner';
import { MainBannerCarousel } from '../main-banner-carousel';
import { Banner } from '../banner';
import { IntraSection } from '../intra-section';
import styles from './MainBody.css';

const IPropTypes = {
  homeData: PropTypes.shape({
    alert: PropTypes.shape({
      lines: PropTypes.array,
    }),
    sections: PropTypes.array,
  }).isRequired,
};

class MainBody extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      alertEnabled: true,
    };
    this._closeAlert = this._closeAlert.bind(this);
    this._renderSection = this._renderSection.bind(this);
    // The main banner should be constant as long as this component
    // is on screen. That's why we select a random number here.
    this.normalizedIndex = Math.random();
  }

  _closeAlert() {
    this.setState({
      alertEnabled: false,
    });
  }

  _renderSection(section) {
    if (section.type === SECTION_TYPES.PRODUCT_LIST) {
      const products = section.products.map(product => (
        <ProductCard
          className={styles.productCard}
          key={product.id}
          product={product}
        />
      ));
      return (
        <section
          className={[styles.genericSection, styles.internalContainer].join(' ')}
          key={section.name}
        >
          <h2 className={styles.sectionTitle}>
            {section.name}
          </h2>
          <div className={styles.productList}>
            {products}
          </div>
        </section>
      );
    } else if (section.type === SECTION_TYPES.MAIN_BANNER) {
      // Select randomly from the present banners
      const bannerIndex = Math.floor(this.normalizedIndex * section.banners.length);
      const banner = section.banners[bannerIndex];
      return (
        <section key={banner.id}>
          <MainBannerCarousel banners={section.banners} />
        </section>
      );
    } else if (section.type === SECTION_TYPES.BANNER) {
      const banner = section.banners[0];
      return (
        <section className={styles.internalContainer} key={banner.id}>
          <Banner
            banner={banner}
          />
        </section>
      );
    } else if (section.type === SECTION_TYPES.INTRA) {
      const sectionsIntra = section.sectionsIntra.map(intraSection => (
        <IntraSection
          className={styles.intraCard}
          key={intraSection.title}
          intraSection={intraSection}
        />
      ));
      return (
        <section
          className={[styles.genericSection, styles.internalContainer].join(' ')}
          key={section.name}
        >
          <h2 className={styles.sectionTitle}>
            {section.name}
          </h2>
          <div className={styles.intraList}>
            {sectionsIntra}
          </div>
        </section>
      );
    }
    return null;
  }

  render() {
    return (
      <div className={styles.container}>
        {
          this.props.homeData !== null &&
          !!this.props.homeData.alert &&
          this.state.alertEnabled &&
          <div className={styles.alertContainer}>
            <div className={styles.internalAlertContainer}>
              <Alert
                onClose={this._closeAlert}
                lines={this.props.homeData.alert.lines}
              />
            </div>
          </div>
        }
        <div>
          {
            this.props.homeData !== null &&
            this.props.homeData.sections.map(this._renderSection)
          }
        </div>
      </div>
    );
  }
}

MainBody.propTypes = IPropTypes;

export { MainBody };



// WEBPACK FOOTER //
// ./src/pages/home/main-body/MainBody.jsx